import { cdnData } from '@xsite-ui/common.cdn';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { PROFILE_FIELDS_KEYS, linkBlue, warningRed, darkGrey, minDesktopWidth, black, greyscale4, mainGreen, darkGreen, grey, dropdownHover, statesList, getPixelLabelJSON } from '@xsite-ui/prequal-funnels.constants';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import CleanInput from '@xsite-ui/prequal-funnels.assets/clean-input';
import PoweredByGoogleIcon from '@xsite-ui/prequal-funnels.assets/powered-by-google';
import { Image } from '@xsite-ui/common.image';
import LockIcon from '@xsite-ui/prequal-funnels.assets/lock-icon';
import ValidationCheckIcon from '@xsite-ui/prequal-funnels.assets/valid';
import ValidationGiftIcon from '@xsite-ui/prequal-funnels.assets/validation-gift';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import DropdownArrowIcon from '@xsite-ui/prequal-funnels.assets/dropdown-arrow';
import { RangeSlider as RangeSlider$1, MinusIcon, PlusIcon } from '@xsite-ui/prequal-funnels.assets';
import throttle from 'lodash.throttle';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var prepareFullAddressValues = function prepareFullAddressValues(questionnaireStepInputState) {
  var _questionnaireStepInp;

  var address = {
    street_address: '',
    street_address_2: '',
    city: '',
    state: '',
    zip_code: '',
    fullAddress: ''
  };

  if (!Array.isArray(questionnaireStepInputState) || ((_questionnaireStepInp = questionnaireStepInputState[0]) === null || _questionnaireStepInp === void 0 ? void 0 : _questionnaireStepInp.key) !== 'fullAddress') {
    return address;
  }

  questionnaireStepInputState.map(function (questionInput) {
    address[questionInput.key] = questionInput.value;
  });
  return address;
};
var normalizeDateFromQuestionnaire = function normalizeDateFromQuestionnaire(dateInputValue) {
  var splitDate = dateInputValue.split('-');

  if (splitDate.length === 3) {
    var _splitDate = _slicedToArray(splitDate, 3),
        year = _splitDate[0],
        month = _splitDate[1],
        day = _splitDate[2];

    return "".concat(month).concat(day).concat(year);
  }

  return dateInputValue;
};
var getAutoCompleteValue = function getAutoCompleteValue(profileKey) {
  switch (profileKey) {
    case 'zip_code':
      return 'zipcode';

    case 'email':
      return 'email';

    case 'date_of_birth':
      return 'bday';

    case 'first_name':
      return 'given-name';

    case 'last_name':
      return 'family-name';

    case 'phone':
    case 'primary_phone':
      return 'tel';

    default:
      return 'off';
  }
};
var getInputNameValue = function getInputNameValue(profileKey) {
  switch (profileKey) {
    case 'zip_code':
      return 'zipcode';

    case 'email':
      return 'email';

    case 'date_of_birth':
      return 'dob';

    case 'first_name':
      return 'firstName';

    case 'last_name':
      return 'lastName';

    case 'phone':
    case 'primary_phone':
      return 'tel';

    case 'ssn':
      return 'ssn';

    case 'password':
      return 'password';

    default:
      return 'off';
  }
};
var getValidationIconByProfileKey = function getValidationIconByProfileKey(profileKey) {
  switch (profileKey) {
    case PROFILE_FIELDS_KEYS.dob:
      return 'gift';

    case PROFILE_FIELDS_KEYS.firstName:
    case PROFILE_FIELDS_KEYS.lastName:
    case PROFILE_FIELDS_KEYS.email:
    case PROFILE_FIELDS_KEYS.primaryPhone:
    case PROFILE_FIELDS_KEYS.annualIncome:
      return 'check';

    case PROFILE_FIELDS_KEYS.ssn:
      return 'lock';

    default:
      return '';
  }
};

var _templateObject$a, _templateObject2$9, _templateObject3$8;
var AddressWrapper = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n"])));
var SwitchViews = styled.p(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 16px;\n  padding-top: 5px;\n  text-align: center;\n"])));
var SwitchViewsLink = styled.button(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  font-weight: 600;\n  text-decoration: underline;\n  border: 0;\n  background-color: transparent;\n  cursor: pointer;\n"])), linkBlue);

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var _templateObject$9;
var WarningTextSpan = styled.span(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: ", ";\n  font-weight: 400;\n  font-size: 14px;\n  width: 100%;\n  max-width: 412px;\n  margin-top: 8px;\n  line-height: 17px;\n  text-align: left;\n  animation: ", ";\n"])), function (props) {
  return props !== null && props !== void 0 && props.isError ? "".concat(warningRed) : "".concat(darkGrey);
}, function (props) {
  return props !== null && props !== void 0 && props.animation ? "".concat(props.animation, " 1s both") : '';
});

var WarningText = function WarningText(_ref) {
  var text = _ref.text,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? '' : _ref$animation,
      _ref$isError = _ref.isError,
      isError = _ref$isError === void 0 ? true : _ref$isError;
  return /*#__PURE__*/React.createElement(WarningTextSpan, {
    animation: animation,
    isError: isError,
    "data-testid": "warning-test"
  }, text);
};

var _templateObject$8, _templateObject2$8, _templateObject3$7, _templateObject4$5, _templateObject5$3;
var shrinkLabel = "\n    transition: 0.3s ease all;\n    font-size: 12px;\n    top: 0;\n    left: 10px;\n    padding: 0 2px;\n    margin: 0 4px;\n    background-color: white;\n    z-index: 2;\n    font-weight: 400;";
var Wrapper = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  @media (min-width: ", ") {\n    max-width: 428px;\n  }\n"])), minDesktopWidth);
var InputContainer = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  appearance: none;\n  box-shadow: none;\n  position: relative;\n  width: 100%;\n  max-height: 60px;\n  color: ", ";\n  z-index: 2;\n"])), black);
var Input = styled.input(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  box-shadow: none;\n  background-color: transparent;\n  position: relative;\n  padding: 16px;\n  width: 100%;\n  height: 60px;\n  border-radius: 3px;\n  z-index: 2;\n  transition: border 0.3s;\n  appearance: none;\n  --webkit-appearance: none;\n  font-size: 18px;\n  font-weight: 600;\n  ", "\n  -webkit-box-shadow: 0 0 0px 1000px #ffffff inset; // to override blue auto complete chrome color\n  &:focus {\n    outline: none;\n  }\n  &:focus ~ label {\n    ", "\n  }\n  &:focus ~ span {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  @media (min-width: ", ") {\n    &:hover {\n      border-color: ", ";\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"])), greyscale4, function (props) {
  return props !== null && props !== void 0 && props.shouldIndentText ? "padding-left: 44px;" : '';
}, shrinkLabel, black, mainGreen, minDesktopWidth, mainGreen, function (props) {
  return (props === null || props === void 0 ? void 0 : props.name) === 'rangeSlider' ? "\n        text-align: center;\n        padding: 0;\n        font-size: 28px;\n        pointer-events: none;\n      " : '';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.name) === 'ssn' ? "\n      ~ span {\n        caret-color: #171717;\n        font-size: 15px;\n        letter-spacing: 6px;\n      }\n      " : '';
}, function (props) {
  return props !== null && props !== void 0 && props.value ? "border-color: ".concat(mainGreen, ";\n        & ~ span {\n          color: ").concat(black, ";\n        }") : "";
}, function (props) {
  return props !== null && props !== void 0 && props.hideValue ? "color: transparent; \n      -webkit-text-fill-color: transparent;\n      letter-spacing: 1.8px;\n\n      &::selection {\n        color: transparent;\n        background-color: #e8f0fe;\n      }\n\n      & ~ label {\n        ".concat(shrinkLabel, "\n      }\n      ") : "";
}, function (props) {
  var isValid = props.isValid;

  if (isValid === 'true') {
    return "border-color: ".concat(darkGreen, ";\n   \n        &:focus {\n          border-color: ").concat(darkGreen, ";\n        }\n        @media (min-width: ").concat(minDesktopWidth, ") {\n        &:hover {\n          border-color: ").concat(darkGreen, ";\n        }\n      }");
  }

  if (isValid === 'false') {
    return "border-color: ".concat(warningRed, ";   \n        &:focus {\n          border-color: ").concat(warningRed, ";\n        }\n        @media (min-width: ").concat(minDesktopWidth, ") {\n          &:hover {\n          border-color: ").concat(warningRed, ";\n        }\n      }");
  }

  return "";
});
var InputLabel = styled.label(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n  transition: 0.3s ease all;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  z-index: 4;\n  pointer-events: none;\n  width: max-content;\n  max-width: inherit;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  color: ", ";\n  background-color: transparent;\n  letter-spacing: -0.2px;\n  line-height: 18px;\n  pointer-events: none;\n  ", "\n  ", "\n  &:active {\n    border: 1px solid ", ";\n  }\n"])), darkGrey, function (props) {
  return props !== null && props !== void 0 && props.shouldIndentText ? "margin-left: 44px;" : 'left: 16px;';
}, function (props) {
  return props !== null && props !== void 0 && props.value ? shrinkLabel : '';
}, mainGreen);
var InputDisplayText = styled.span(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  user-select: none;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  z-index: 4;\n  pointer-events: none;\n  width: max-content;\n  max-width: inherit;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: ", ";\n  background-color: transparent;\n  box-sizing: border-box;\n  font-size: 18px;\n  font-weight: 600;\n  transition: color 0.3s;\n  ", "\n"])), darkGrey, function (props) {
  return props !== null && props !== void 0 && props.shouldIndentText ? "margin-left: 44px;" : 'left: 16px;';
});

var BaseInput = function BaseInput(_ref) {
  var id = _ref.id,
      type = _ref.type,
      name = _ref.name,
      placeholder = _ref.placeholder,
      displayText = _ref.displayText,
      value = _ref.value,
      handleChange = _ref.handleChange,
      leftIcon = _ref.leftIcon,
      leftBtn = _ref.leftBtn,
      rightBtn = _ref.rightBtn,
      validationIcon = _ref.validationIcon,
      isInputValid = _ref.isInputValid,
      errorAnimation = _ref.errorAnimation,
      errorText = _ref.errorText,
      underText = _ref.underText,
      autoComplete = _ref.autoComplete,
      reference = _ref.reference,
      _ref$testid = _ref.testid,
      testid = _ref$testid === void 0 ? 'base-input' : _ref$testid;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(InputContainer, {
    "data-testid": "input-container"
  }, leftIcon, leftBtn, /*#__PURE__*/React.createElement(Input, {
    id: id,
    ref: reference,
    name: name,
    type: type,
    value: value,
    onChange: handleChange,
    isValid: isInputValid || errorText ? isInputValid.toString() : '',
    shouldIndentText: Boolean(leftIcon),
    hideValue: Boolean(displayText),
    autoComplete: autoComplete,
    "data-testid": testid,
    "data-valid": isInputValid
  }), placeholder && /*#__PURE__*/React.createElement(InputLabel, {
    value: value,
    htmlFor: id,
    shouldIndentText: Boolean(leftIcon),
    "data-testid": "base-input-placeholder"
  }, placeholder), displayText && /*#__PURE__*/React.createElement(InputDisplayText, {
    shouldIndentText: Boolean(leftIcon)
  }, displayText), validationIcon && validationIcon, rightBtn), isInputValid && underText && /*#__PURE__*/React.createElement(WarningText, {
    text: underText,
    animation: errorAnimation,
    isError: false
  }), !isInputValid && errorText && /*#__PURE__*/React.createElement(WarningText, {
    text: errorText,
    animation: errorAnimation,
    isError: true
  }));
};

var _templateObject$7, _templateObject2$7, _templateObject3$6, _templateObject4$4, _templateObject5$2, _templateObject6$1, _templateObject7, _templateObject8, _templateObject9;
var GoogleAddressContainer = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  position: relative;\n  > div {\n    padding-bottom: 0;\n  }\n\n  @media (min-width: ", ") {\n    width: 412px;\n    align-self: center;\n  }\n"])), minDesktopWidth);
var PredictionList = styled.ul(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  animation: fadeIn 0.2s both;\n  width: 100%;\n  position: absolute;\n  z-index: 20;\n  top: 58px;\n"])));
var PredictionListItem = styled.li(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  text-align: left;\n  height: 60px;\n  padding: 20px 16px;\n  color: #010233;\n  font-size: 16px;\n  letter-spacing: -0.18px;\n  line-height: 18px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-bottom: none;\n  border-radius: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  cursor: pointer;\n  z-index: 20;\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), darkGrey, grey, darkGrey, dropdownHover);
var ToolTip = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  height: 0;\n  box-shadow: 0 8px 19px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  border: 1px solid #b2b3c1;\n  background-color: #ffffff;\n  position: absolute;\n  margin-top: 2px;\n  padding: 18px 0 0 16px;\n  z-index: 3;\n  opacity: 0;\n  transition: all 0.3s;\n  visibility: hidden;\n  cursor: pointer;\n  display: none;\n  width: 100%;\n\n  ", "\n"])), function (props) {
  return props !== null && props !== void 0 && props.showToolTip ? "    \n      display: flex;\n      opacity: 1;\n      height: 61px;\n      visibility: visible;\n      " : '';
});
var ToolTipArrow = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-right: 7px solid transparent;\n  border-bottom: 9px solid #b2b3c1;\n  border-left: 7px solid transparent;\n  position: absolute;\n  background-color: transparent;\n  top: -10px;\n  left: 49%;\n\n  &::after {\n    content: '';\n    width: 0;\n    height: 0;\n    border-right: 7px solid transparent;\n    border-bottom: 9px solid white;\n    border-left: 7px solid transparent;\n    position: absolute;\n    top: calc(100% + 1px);\n    right: calc(100% - 7px);\n  }\n"])));
var ToolTipText = styled.span(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 20px;\n  height: fit-content;\n"])));
var ToolTipLink = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  font-weight: 600;\n  text-decoration: underline;\n  border: 0;\n  background-color: transparent;\n  line-height: 20px;\n  height: fit-content;\n  margin-left: 5px;\n  cursor: pointer;\n"])), linkBlue);
var PoweredByGoogle = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 120px;\n  display: flex;\n  padding-top: 8px;\n  padding-bottom: 20px;\n  margin-left: auto;\n  & svg {\n    display: block;\n    right: 0;\n    width: 100%;\n  }\n"])));
var ClearFieldButton = styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  height: 60px;\n  width: 20px;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n  right: 16px;\n  top: 0;\n  z-index: 3;\n  cursor: pointer;\n"])));

var inputKey = 'fullAddress';
var componentForm = {
  route: {
    value: 'long_name',
    field: 'street_address'
  },
  locality: {
    value: 'long_name',
    field: 'city'
  },
  // in order of specificity for city
  administrative_area_level_3: {
    value: 'long_name',
    field: 'city'
  },
  administrative_area_level_2: {
    value: 'long_name',
    field: 'city'
  },
  sublocality_level_1: {
    value: 'long_name',
    field: 'city'
  },
  administrative_area_level_1: {
    value: 'short_name',
    field: 'state'
  },
  postal_code: {
    value: 'short_name',
    field: 'zip_code'
  },
  street_number: {
    value: 'long_name',
    field: 'street_address'
  }
};
var ADDRESS_KEYS = ['street_address', 'street_address_2', 'city', 'state', 'zip_code'];
var GoogleAddress = function GoogleAddress(_ref) {
  var address = _ref.address,
      isAddressFormValid = _ref.isAddressFormValid,
      onInputChange = _ref.onInputChange,
      changeView = _ref.changeView;

  var _useState = useState(address['fullAddress'] || ''),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showPredictions = _useState4[0],
      setShowPredictions = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      predictions = _useState6[0],
      setPredictions = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isSuggestionsLoading = _useState8[0],
      setSuggestionsLoading = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      autoCompleteService = _useState10[0],
      setAutoCompleteService = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      placesService = _useState12[0],
      setPlacesService = _useState12[1];

  var _useState13 = useState(isAddressFormValid),
      _useState14 = _slicedToArray(_useState13, 2),
      isValidForm = _useState14[0],
      setIsValidForm = _useState14[1];

  var autoCompleteRef = useRef(null);
  useEffect(function () {
    onInputChange(address, isValidForm);
  }, [isValidForm]);
  useEffect(function () {
    setIsValidForm(checkValidForm(address));
  }, [address]);

  var checkValidForm = function checkValidForm(testedAddress) {
    var isFormValid = true;

    for (var _i = 0, _Object$entries = Object.entries(testedAddress); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          fieldKey = _Object$entries$_i[0],
          fieldValue = _Object$entries$_i[1];

      if (!fieldValue && fieldKey !== 'street_address_2') {
        isFormValid = false;
      }
    }

    return isFormValid;
  };

  var initGooglePlacesServices = function initGooglePlacesServices() {
    if (window) {
      setAutoCompleteService(new window.google.maps.places.AutocompleteService());
      setPlacesService(new window.google.maps.places.PlacesService(autoCompleteRef.current));
    }
  };

  useEffect(function () {
    var _window, _window$google, _window$google$maps;

    if ((_window = window) !== null && _window !== void 0 && (_window$google = _window.google) !== null && _window$google !== void 0 && (_window$google$maps = _window$google.maps) !== null && _window$google$maps !== void 0 && _window$google$maps.places) {
      initGooglePlacesServices();
    }
  }, []);

  var updateAndSaveAddressValues = function updateAndSaveAddressValues(queryVal, addressValues) {
    setQuery(queryVal);
    setShowPredictions(false);

    var _iterator = _createForOfIteratorHelper(addressValues),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var addressValue = _step.value;
        var isValueValid = true;
        var addressType = addressValue.types[0];

        if (componentForm[addressType]) {
          var val = addressValue[componentForm[addressType].value];
          var fieldKey = componentForm[addressType].field;

          if (addressType === 'locality') {
            address[fieldKey] = val;
          }

          if (addressType === 'street_number') {
            address[fieldKey] = "".concat(val, " ").concat(address[fieldKey]).trim();
          }

          if (addressType === 'route') {
            address[fieldKey] = "".concat(address[fieldKey], " ").concat(val).trim();
          }

          if (!address[fieldKey]) {
            address[fieldKey] = val;
          }

          address[inputKey] = queryVal;

          if (!isValidValue(val)) {
            isValueValid = false;
          }

          isValueValid = checkValidForm(address);
          setIsValidForm(isValueValid);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var handleSelectItem = function handleSelectItem(pred) {
    placesService.getDetails({
      placeId: pred.place_id,
      fields: ['address_components', 'formatted_address']
    }, function (place, status) {
      if (window && status === window.google.maps.places.PlacesServiceStatus.OK) {
        updateAndSaveAddressValues(place.formatted_address, place.address_components);
      }
    });
  };

  var isValidValue = function isValidValue(value) {
    // need to rework
    if (!value) {
      return false;
    }

    return true;
  };

  var getPredictionListMarkup = function getPredictionListMarkup(predictionsVal) {
    if (predictionsVal && predictionsVal.length > 0) {
      return /*#__PURE__*/React.createElement(PredictionList, {
        "data-testid": "predictions-list"
      }, predictionsVal.map(function (pred, index) {
        var key = "".concat(JSON.stringify(pred).slice(0, 10)).concat(index, "}");
        return /*#__PURE__*/React.createElement(PredictionListItem, {
          key: key,
          onClick: function onClick() {
            return handleSelectItem(pred);
          },
          "data-testid": "prediction-".concat(index)
        }, pred.description);
      }));
    }

    return null;
  };

  var displayPredictionSuggestions = function displayPredictionSuggestions(predictionsVal, status) {
    if (window && status !== window.google.maps.places.PlacesServiceStatus.OK) {
      setSuggestionsLoading(false);
      setShowPredictions(false);
      return;
    }

    setSuggestionsLoading(true);
    setShowPredictions(true);
    setPredictions(predictionsVal);
  };

  var clearSuggestions = function clearSuggestions() {
    setShowPredictions(false);
    setPredictions([]);
  };

  var checkForAddressValues = function checkForAddressValues() {
    return Object.keys(address).find(function (keyName) {
      var _address$keyName;

      if (keyName === 'fullAddress' || keyName === 'property_address') {
        return false;
      }

      return (_address$keyName = address[keyName]) === null || _address$keyName === void 0 ? void 0 : _address$keyName.length;
    });
  };

  var toolTipMarkup = function toolTipMarkup() {
    var hasAtLeastOneAddressValue = checkForAddressValues();
    var showToolTip = !showPredictions && query.length > 2 && !isSuggestionsLoading && !hasAtLeastOneAddressValue;
    return /*#__PURE__*/React.createElement(ToolTip, {
      showToolTip: showToolTip,
      onClick: function onClick() {
        return changeView();
      },
      "data-testid": "tooltip"
    }, /*#__PURE__*/React.createElement(ToolTipArrow, null), /*#__PURE__*/React.createElement(ToolTipText, null, "Can't find the address? "), /*#__PURE__*/React.createElement(ToolTipLink, {
      "data-testid": "tooltip-link"
    }, "Enter it manually"));
  };

  var handleInputChange = function handleInputChange() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    setSuggestionsLoading(true);
    setQuery(val);

    if (!val) {
      handleInputClear();
    }

    var _iterator2 = _createForOfIteratorHelper(ADDRESS_KEYS),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var keyVal = _step2.value;
        address[keyVal] = '';
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    address[inputKey] = val; // updateForm(val);

    if (/[^\d ,A-Za-z-]/.test(val) || val && val.length < 3 || !val) {
      setSuggestionsLoading(false);
      clearSuggestions();
    } else {
      // should debounce?
      autoCompleteService.getPlacePredictions({
        input: val,
        types: ["geocode"],
        componentRestrictions: {
          country: 'us'
        }
      }, function (predictionsArr, status) {
        displayPredictionSuggestions(predictionsArr, status);
      });
    }
  };

  var handleInputClear = function handleInputClear() {
    setIsValidForm(false);
    setSuggestionsLoading(false);
    setQuery('');
    clearSuggestions();

    for (var _i2 = 0, _Object$entries2 = Object.entries(address); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 1),
          fieldKey = _Object$entries2$_i[0];

      address[fieldKey] = '';
    }
  };

  return /*#__PURE__*/React.createElement(GoogleAddressContainer, {
    "data-testid": "google-address-wrapper"
  }, /*#__PURE__*/React.createElement(BaseInput, {
    id: "street_address",
    type: "text",
    value: query,
    placeholder: 'Street Address, City, State',
    displayText: "",
    handleChange: function handleChange(e) {
      return handleInputChange(e.target.value);
    },
    leftIcon: undefined,
    validationIcon: undefined,
    isInputValid: isValidForm,
    errorAnimation: "",
    errorText: "",
    underText: "",
    autoComplete: "off",
    reference: autoCompleteRef,
    name: "address",
    testid: "google-address-input"
  }), !!query && /*#__PURE__*/React.createElement(ClearFieldButton, {
    onClick: handleInputClear
  }, /*#__PURE__*/React.createElement(CleanInput, null)), /*#__PURE__*/React.createElement(PoweredByGoogle, {
    "data-testid": "powered-by-google-icon"
  }, /*#__PURE__*/React.createElement(PoweredByGoogleIcon, null)), showPredictions && getPredictionListMarkup(predictions), toolTipMarkup());
};

var _templateObject$6, _templateObject2$6, _templateObject3$5;
var ListWrapper$1 = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  z-index: 6;\n  @media (min-width: ", ") {\n    max-width: 428px;\n  }\n"])), minDesktopWidth);
var InputSelectList = styled.ul(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: absolute;\n  width: 100%;\n  top: 60px;\n  left: 0;\n  overflow-y: scroll;\n  overflow-x: visible;\n  -ms-overflow-style: none;\n  max-height: 175px;\n  transform-origin: top;\n  transition: opacity 0.3s, transform 0.3s;\n  scroll-snap-type: y mandatory;\n  scroll-behavior: smooth;\n  opacity: 0;\n  height: 0;\n\n  &::-webkit-scrollbar {\n    appearance: none;\n    display: none;\n  }\n  ", "\n  z-index: 6;\n"])), function (props) {
  return props !== null && props !== void 0 && props.isListOpen ? "    \n      opacity: 1;\n      z-index: 10;\n      height: unset;" : '';
});
var InputListItem = styled.li(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  z-index: 6;\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  height: 55px;\n  border: 1px solid ", ";\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 16px;\n  font-size: 16px;\n  scroll-snap-align: center center;\n  scroll-snap-stop: always;\n  cursor: pointer;\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), grey, black, darkGrey, dropdownHover);

var ListInput = function ListInput(_ref) {
  var id = _ref.id,
      placeholder = _ref.placeholder,
      stateValue = _ref.stateValue,
      list = _ref.list,
      onItemSelect = _ref.onItemSelect,
      _ref$errorText = _ref.errorText,
      errorText = _ref$errorText === void 0 ? 'Please select a valid value' : _ref$errorText;

  var getDisplayValue = function getDisplayValue(value) {
    var listItem = list.find(function (listItem) {
      return listItem.value.toLowerCase() === value.toLowerCase();
    });
    return (listItem === null || listItem === void 0 ? void 0 : listItem.displayValue) || '';
  };

  var _useState = useState(getDisplayValue(stateValue)),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(list),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredList = _useState4[0],
      setFilteredList = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isListOpen = _useState6[0],
      setIsListOpen = _useState6[1];

  var _useState7 = useState(!!stateValue),
      _useState8 = _slicedToArray(_useState7, 2),
      isValid = _useState8[0],
      setIsValid = _useState8[1];

  var handleInputChange = function handleInputChange(userValue) {
    setInputValue(userValue);
    filterAndSetList(userValue);

    if (!filteredList || filteredList.length === 0) {
      setIsValid(false);
    } else {
      var isValueValid = validateListItem(userValue, filteredList);
      setIsValid(isValueValid);
      var fullAnswer = filteredList.find(function (state) {
        return state.displayValue === userValue;
      });

      if (fullAnswer) {
        onItemSelect(fullAnswer.value);
      } else {
        onItemSelect('');
      }
    }
  };

  var validateListItem = function validateListItem(value, itemList) {
    return itemList.some(function (_ref2) {
      var displayValue = _ref2.displayValue;
      return displayValue.toLocaleLowerCase() === value.toLocaleLowerCase();
    });
  };

  var filterAndSetList = function filterAndSetList(userValue) {
    var newFilteredList = filterListByValue(userValue);
    setFilteredList(newFilteredList);
  };

  var filterListByValue = function filterListByValue() {
    var userValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!userValue) {
      return list;
    }

    return list.filter(function (_ref3) {
      var value = _ref3.value,
          displayValue = _ref3.displayValue;
      var lowerCaseUserValue = userValue.toLocaleLowerCase();
      var lowerCaseValue = value.toLocaleLowerCase();
      var lowerCaseDisplayValue = displayValue.toLocaleLowerCase();
      return lowerCaseValue.includes(lowerCaseUserValue) || lowerCaseDisplayValue.includes(lowerCaseUserValue);
    });
  };

  var handleListClick = function handleListClick(displayValue, value) {
    setInputValue(displayValue);
    setIsValid(true);
    onItemSelect(value);
  };

  var getSelectList = function getSelectList(filteredListArr) {
    return filteredListArr.map(function (_ref4) {
      var value = _ref4.value,
          displayValue = _ref4.displayValue;
      return /*#__PURE__*/React.createElement(InputListItem, {
        value: value,
        key: value,
        onClick: function onClick() {
          return handleListClick(displayValue, value);
        },
        onKeyDown: function onKeyDown() {
          return handleListClick(displayValue, value);
        }
      }, displayValue);
    });
  };

  return /*#__PURE__*/React.createElement(ListWrapper$1, {
    "data-testid": "list-input-wrapper"
  }, /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Input, {
    id: id,
    name: "list-input",
    value: inputValue,
    onChange: function onChange(e) {
      return handleInputChange(e.target.value);
    },
    isValid: isValid || errorText ? isValid.toString() : '',
    "data-testid": "list-input",
    onFocus: function onFocus() {
      setIsListOpen(true);
      filterAndSetList(inputValue);
    },
    onBlur: function onBlur() {
      return setTimeout(function () {
        setIsListOpen(false);
      }, 250);
    },
    autoComplete: "off"
  }), placeholder && /*#__PURE__*/React.createElement(InputLabel, {
    value: inputValue,
    htmlFor: id,
    "data-testid": "list-input-placeholder"
  }, placeholder), /*#__PURE__*/React.createElement(InputSelectList, {
    "data-testid": "input-select-list",
    isListOpen: isListOpen
  }, getSelectList(filteredList))), !isValid && errorText && /*#__PURE__*/React.createElement(WarningText, {
    text: errorText,
    animation: "fadeIn",
    isError: true
  }));
};

var zipcodeValidationFunc = function zipcodeValidationFunc(value) {
  var zipCodeObject = convertZip(value);

  if (value.length < 5) {
    return {
      isValid: false,
      validationText: ''
    };
  }

  if (!(zipCodeObject !== null && zipCodeObject !== void 0 && zipCodeObject.code) && !(zipCodeObject !== null && zipCodeObject !== void 0 && zipCodeObject["long"])) {
    return {
      isValid: false,
      validationText: 'Please enter a valid zip code'
    };
  }

  var _long = zipCodeObject["long"],
      code = zipCodeObject.code;
  return {
    isValid: true,
    validationText: "".concat(_long, ", ").concat(code)
  };
};

var convertZip = function convertZip(zip) {
  var zipCode = zip;

  if (typeof zipCode === 'string') {
    zipCode = Number.parseInt(zipCode, 10);
  } // Ensure you don't parse codes that start with 0 as octal values


  var states = [{
    min: 35000,
    max: 36999,
    code: 'AL',
    "long": 'Alabama'
  }, {
    min: 99500,
    max: 99999,
    code: 'AK',
    "long": 'Alaska'
  }, {
    min: 85000,
    max: 86999,
    code: 'AZ',
    "long": 'Arizona'
  }, {
    min: 71600,
    max: 72999,
    code: 'AR',
    "long": 'Arkansas'
  }, {
    min: 90000,
    max: 96699,
    code: 'CA',
    "long": 'California'
  }, {
    min: 80000,
    max: 81999,
    code: 'CO',
    "long": 'Colorado'
  }, {
    min: 6000,
    max: 6999,
    code: 'CT',
    "long": 'Connecticut'
  }, {
    min: 19700,
    max: 19999,
    code: 'DE',
    "long": 'Delaware'
  }, {
    min: 32000,
    max: 34999,
    code: 'FL',
    "long": 'Florida'
  }, {
    min: 30000,
    max: 31999,
    code: 'GA',
    "long": 'Georgia'
  }, {
    min: 96700,
    max: 96999,
    code: 'HI',
    "long": 'Hawaii'
  }, {
    min: 83200,
    max: 83999,
    code: 'ID',
    "long": 'Idaho'
  }, {
    min: 60000,
    max: 62999,
    code: 'IL',
    "long": 'Illinois'
  }, {
    min: 46000,
    max: 47999,
    code: 'IN',
    "long": 'Indiana'
  }, {
    min: 50000,
    max: 52999,
    code: 'IA',
    "long": 'Iowa'
  }, {
    min: 66000,
    max: 67999,
    code: 'KS',
    "long": 'Kansas'
  }, {
    min: 40000,
    max: 42999,
    code: 'KY',
    "long": 'Kentucky'
  }, {
    min: 70000,
    max: 71599,
    code: 'LA',
    "long": 'Louisiana'
  }, {
    min: 3900,
    max: 4999,
    code: 'ME',
    "long": 'Maine'
  }, {
    min: 20600,
    max: 21999,
    code: 'MD',
    "long": 'Maryland'
  }, {
    min: 1000,
    max: 2799,
    code: 'MA',
    "long": 'Massachusetts'
  }, {
    min: 48000,
    max: 49999,
    code: 'MI',
    "long": 'Michigan'
  }, {
    min: 55000,
    max: 56999,
    code: 'MN',
    "long": 'Minnesota'
  }, {
    min: 38600,
    max: 39999,
    code: 'MS',
    "long": 'Mississippi'
  }, {
    min: 63000,
    max: 65999,
    code: 'MO',
    "long": 'Missouri'
  }, {
    min: 59000,
    max: 59999,
    code: 'MT',
    "long": 'Montana'
  }, {
    min: 27000,
    max: 28999,
    code: 'NC',
    "long": 'North Carolina'
  }, {
    min: 58000,
    max: 58999,
    code: 'ND',
    "long": 'North Dakota'
  }, {
    min: 68000,
    max: 69999,
    code: 'NE',
    "long": 'Nebraska'
  }, {
    min: 88900,
    max: 89999,
    code: 'NV',
    "long": 'Nevada'
  }, {
    min: 3000,
    max: 3899,
    code: 'NH',
    "long": 'New Hampshire'
  }, {
    min: 7000,
    max: 8999,
    code: 'NJ',
    "long": 'New Jersey'
  }, {
    min: 87000,
    max: 88499,
    code: 'NM',
    "long": 'New Mexico'
  }, {
    min: 10000,
    max: 14999,
    code: 'NY',
    "long": 'New York'
  }, {
    min: 43000,
    max: 45999,
    code: 'OH',
    "long": 'Ohio'
  }, {
    min: 73000,
    max: 74999,
    code: 'OK',
    "long": 'Oklahoma'
  }, {
    min: 97000,
    max: 97999,
    code: 'OR',
    "long": 'Oregon'
  }, {
    min: 15000,
    max: 19699,
    code: 'PA',
    "long": 'Pennsylvania'
  }, {
    min: 300,
    max: 999,
    code: 'PR',
    "long": 'Puerto Rico'
  }, {
    min: 2800,
    max: 2999,
    code: 'RI',
    "long": 'Rhode Island'
  }, {
    min: 29000,
    max: 29999,
    code: 'SC',
    "long": 'South Carolina'
  }, {
    min: 57000,
    max: 57999,
    code: 'SD',
    "long": 'South Dakota'
  }, {
    min: 37000,
    max: 38599,
    code: 'TN',
    "long": 'Tennessee'
  }, {
    min: 75000,
    max: 79999,
    code: 'TX',
    "long": 'Texas'
  }, {
    min: 88500,
    max: 88599,
    code: 'TX',
    "long": 'Texas'
  }, {
    min: 84000,
    max: 84999,
    code: 'UT',
    "long": 'Utah'
  }, {
    min: 5000,
    max: 5999,
    code: 'VT',
    "long": 'Vermont'
  }, {
    min: 22000,
    max: 24699,
    code: 'VA',
    "long": 'Virginia'
  }, {
    min: 20000,
    max: 20599,
    code: 'DC',
    "long": 'Washington DC'
  }, {
    min: 98000,
    max: 99499,
    code: 'WA',
    "long": 'Washington'
  }, {
    min: 24700,
    max: 26999,
    code: 'WV',
    "long": 'West Virginia'
  }, {
    min: 53000,
    max: 54999,
    code: 'WI',
    "long": 'Wisconsin'
  }, {
    min: 82000,
    max: 83199,
    code: 'WY',
    "long": 'Wyoming'
  }];
  var state = states.filter(function (s) {
    return s.min <= +zipCode && s.max >= +zipCode;
  });

  if (state.length === 0 || state.length > 1) {
    return {};
  }

  return {
    code: state[0].code,
    "long": state[0]["long"]
  };
};

var getCustomInputChange = function getCustomInputChange(subtype) {
  switch (subtype) {
    case 'datetime':
    case 'date':
      {
        return dateInputChangeFunc;
      }

    case 'phone':
      {
        return phoneInputChangeFunc;
      }

    case 'ssn':
    case 'password':
      return ssnInputChangeFunc;

    case 'currency':
      return currencyInputChangeFunc;

    default:
      return;
  }
};

var currencyInputChangeFunc = function currencyInputChangeFunc(currencyInputValue) {
  var customDisplayText = '';
  var customValue = '';

  if (!currencyInputValue) {
    return {
      customValue: customValue,
      customDisplayText: customDisplayText
    };
  }

  customDisplayText = Number(currencyInputValue).toLocaleString();
  customValue = currencyInputValue;
  return {
    customValue: customValue,
    customDisplayText: customDisplayText
  };
};

var ssnInputChangeFunc = function ssnInputChangeFunc(ssnInputValue, hideLast4DigitsSSN) {
  var customDisplayText = '';
  var customValue = ssnInputValue;

  if (!ssnInputValue) {
    return {
      ssnInputValue: ssnInputValue,
      customDisplayText: customDisplayText
    };
  }

  var displayVal = '';

  if (hideLast4DigitsSSN) {
    displayVal = '⬤'.repeat(ssnInputValue.length);
  } else {
    displayVal = ssnInputValue.length < 6 ? ssnInputValue.replace(/./g, '⬤').slice(0, -1) + ssnInputValue.slice(-1) : '⬤'.repeat(5) + ssnInputValue.slice(5);
  }

  var splitSsnArray = _toConsumableArray(displayVal);

  var splitValueArray = _toConsumableArray(ssnInputValue);

  var separator = '-';

  if (displayVal.length > 3 && displayVal.length <= 5) {
    splitSsnArray.splice(3, 0, separator);
    splitValueArray.splice(3, 0, separator);
  } else if (displayVal.length > 5 && displayVal.length <= 9) {
    splitSsnArray.splice(3, 0, separator);
    splitSsnArray.splice(6, 0, separator);
    splitValueArray.splice(3, 0, separator);
    splitValueArray.splice(6, 0, separator);
  }

  customDisplayText = splitSsnArray.join('');
  customValue = splitValueArray.join('');
  return {
    customValue: customValue,
    customDisplayText: customDisplayText
  };
};

var phoneInputChangeFunc = function phoneInputChangeFunc(phoneInputValue) {
  var customDisplayText = '';
  var customValue = '';

  if (!phoneInputValue) {
    return {
      customValue: customValue,
      customDisplayText: customDisplayText
    };
  }

  var splitPhoneArray = _toConsumableArray(phoneInputValue);

  var separator = '-';

  if (phoneInputValue.length > 3 && phoneInputValue.length <= 6) {
    splitPhoneArray.splice(3, 0, separator);
  } else if (phoneInputValue.length > 6 && phoneInputValue.length <= 10) {
    splitPhoneArray.splice(3, 0, separator);
    splitPhoneArray.splice(7, 0, separator);
  }

  customDisplayText = splitPhoneArray.join('');
  customValue = phoneInputValue;
  return {
    customValue: customValue,
    customDisplayText: customDisplayText
  };
};

var dateInputChangeFunc = function dateInputChangeFunc(dateInputValue) {
  var customDisplayText = 'mm/dd/yyyy';
  var customValue = '';

  if (!dateInputValue) {
    return {
      customValue: customValue,
      customDisplayText: customDisplayText
    };
  }

  var defaultDisplayTextArray = _toConsumableArray('mm/dd/yyyy');

  var dateValueArray = _toConsumableArray(dateInputValue);

  var displayTextArray = [];
  customDisplayText = '';
  var index = 0;

  var _iterator = _createForOfIteratorHelper(defaultDisplayTextArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _char = _step.value;

      if (dateValueArray.length > index && _char !== '/') {
        displayTextArray.push(dateValueArray[index]);
        index += 1;
      } else {
        displayTextArray.push(_char);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  customDisplayText = displayTextArray.join('');

  var _customDisplayText$sp = customDisplayText.split('/'),
      _customDisplayText$sp2 = _slicedToArray(_customDisplayText$sp, 3),
      month = _customDisplayText$sp2[0],
      day = _customDisplayText$sp2[1],
      year = _customDisplayText$sp2[2];

  customValue = "".concat(year, "-").concat(month, "-").concat(day);
  return {
    customValue: customValue,
    customDisplayText: customDisplayText
  };
};

var US_PHONE_AREA_CODES = new Set([228, 601, 662, 769, 670, 405, 539, 580, 918, 302, 218, 320, 507, 612, 651, 763, 952, 217, 224, 309, 312, 331, 618, 630, 708, 773, 779, 815, 847, 872, 479, 501, 870, 505, 575, 219, 260, 317, 574, 765, 812, 240, 301, 410, 443, 667, 225, 318, 337, 504, 985, 208, 307, 423, 615, 731, 865, 901, 931, 480, 520, 602, 623, 928, 319, 515, 563, 641, 712, 231, 248, 269, 313, 517, 586, 616, 734, 810, 906, 947, 989, 316, 620, 785, 913, 385, 435, 801, 684, 458, 503, 541, 971, 203, 475, 860, 406, 209, 213, 310, 323, 408, 415, 424, 442, 510, 530, 559, 562, 619, 626, 650, 657, 661, 669, 707, 714, 747, 760, 805, 818, 831, 858, 909, 916, 925, 949, 951, 339, 351, 413, 508, 617, 774, 781, 857, 978, 787, 939, 803, 843, 864, 603, 262, 414, 534, 608, 715, 920, 802, 229, 404, 470, 478, 678, 706, 762, 770, 912, 701, 215, 267, 272, 412, 484, 570, 610, 717, 724, 814, 878, 304, 681, 239, 305, 321, 352, 386, 407, 561, 727, 754, 772, 786, 813, 850, 863, 904, 941, 954, 808, 270, 502, 606, 859, 907, 308, 402, 531, 314, 417, 573, 636, 660, 816, 216, 234, 330, 419, 440, 513, 567, 614, 740, 937, 205, 251, 256, 334, 938, 401, 202, 340, 605, 303, 719, 720, 970, 201, 551, 609, 732, 848, 856, 862, 908, 973, 276, 434, 540, 571, 703, 757, 804, 671, 206, 253, 360, 425, 509, 252, 336, 704, 828, 910, 919, 980, 984, 212, 315, 347, 516, 518, 585, 607, 631, 646, 716, 718, 845, 914, 917, 929, 210, 214, 254, 281, 325, 346, 361, 409, 430, 432, 469, 512, 682, 713, 737, 806, 817, 830, 832, 903, 915, 936, 940, 956, 972, 979, 702, 725, 775, 207]);
var verifyPhoneAreaCode = function verifyPhoneAreaCode(phoneNumber) {
  if (!phoneNumber) {
    return {
      isValid: false,
      validationText: ''
    };
  }

  if (phoneNumber.length < 3) {
    return {
      isValid: false,
      validationText: ''
    };
  }

  if (US_PHONE_AREA_CODES.has(+phoneNumber.slice(0, 3))) {
    return {
      isValid: true,
      validationText: ''
    };
  }

  return {
    isValid: false,
    validationText: 'Invalid area code'
  };
};
var calculateAge = function calculateAge(dateString) {
  var today = new Date();
  var birthYear = Number(dateString.slice(-4));
  var birthMonth = Number(dateString.slice(0, 2)) - 1;
  var birthDay = Number(dateString.slice(2, 4));
  var birthDate = new Date(birthYear, birthMonth, birthDay);
  var age = today.getFullYear() - birthDate.getFullYear();
  var monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }

  return age;
};
var validateAgeFromDate = function validateAgeFromDate(date) {
  if (date.length === 8 && calculateAge(date) < 18) {
    return {
      isValid: false,
      validationText: 'You must be 18 years of age or older'
    };
  }

  return {
    isValid: true,
    validationText: ''
  };
};
function validateEmail(email) {
  var emailRegex = /^[\w!#$%&'*+/=?^`{|}~-](\.?[\w!#$%&'*+/=?^`{|}~-])*@[\dA-Za-z](-*\.?[\dA-Za-z])*\.[A-Za-z](-?[\dA-Za-z])+$/;
  var dotIndex = email.indexOf('.');

  if (dotIndex !== -1 && email.length - dotIndex > 2 && !emailRegex.test(email)) {
    return {
      isValid: false,
      validationText: 'Please enter a valid email address'
    };
  }

  return {
    isValid: true,
    validationText: ''
  };
}

var getValidationsByType = function getValidationsByType(validationType, options) {
  var validations = {
    regexPattern: undefined,
    minLength: undefined,
    maxLength: undefined,
    minValue: undefined,
    maxValue: undefined,
    inputType: 'text',
    validationFunc: undefined,
    customFunc: undefined,
    dynamicValidation: false,
    warningText: '',
    forbiddenInputRegex: undefined
  };

  switch (validationType) {
    case 'text':
      validations.minLength = 2;
      validations.maxLength = 50;
      validations.inputType = 'text';
      break;

    case 'zipcode':
      validations.minLength = 5;
      validations.maxLength = 5;
      validations.inputType = 'tel';
      validations.forbiddenInputRegex = /\D+/g;
      validations.customFunc = zipcodeValidationFunc;
      break;

    case 'email':
      validations.inputType = 'email';
      validations.regexPattern = /^[\w!#$%&'*+/=?^`{|}~-](\.?[\w!#$%&'*+/=?^`{|}~-])*@[\dA-Za-z](-*\.?[\dA-Za-z])*\.[A-Za-z](-?[\dA-Za-z])+$/;
      validations.validationFunc = validateEmail;
      break;

    case 'datetime':
    case 'date':
      validations.minLength = 8;
      validations.maxLength = 8;
      validations.regexPattern = /^(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])(?:19|20)\d\d$/g;
      validations.forbiddenInputRegex = /\D+/g;
      validations.validationFunc = validateAgeFromDate;
      break;

    case 'phone':
      validations.minLength = 10;
      validations.maxLength = 10;
      validations.forbiddenInputRegex = /\D+/g;
      validations.inputType = 'tel';
      validations.validationFunc = verifyPhoneAreaCode;
      break;

    case 'rangeSlider':
      validations.minValue = 0;
      validations.inputType = 'rangeSlider';
      break;

    case 'ssn':
    case 'password':
      validations.minLength = 9;
      validations.maxLength = 9;
      validations.forbiddenInputRegex = /\D+/g;
      validations.inputType = 'tel';
      validations.regexPattern = /^(?!\b(\d)\1{2}(\d)\1{2}(\d)\1{2}\b)(?!123456789|219099999|078051120)(?!666|000|9\d{2})\d{9}$/;
      break;

    case 'currency':
      validations.forbiddenInputRegex = /^0|\D+$/g;
      validations.inputType = 'tel';
      break;
  }

  if (options) {
    var regexPattern = options.regexPattern,
        minLength = options.minLength,
        maxLength = options.maxLength,
        minValue = options.minValue,
        maxValue = options.maxValue,
        inputType = options.inputType,
        validationFunc = options.validationFunc,
        customFunc = options.customFunc,
        dynamicValidation = options.dynamicValidation,
        warningText = options.warningText,
        forbiddenInputRegex = options.forbiddenInputRegex;
    validations.regexPattern = regexPattern !== null && regexPattern !== void 0 ? regexPattern : validations.regexPattern;
    validations.minLength = minLength !== null && minLength !== void 0 ? minLength : validations.minLength;
    validations.maxLength = maxLength !== null && maxLength !== void 0 ? maxLength : validations.maxLength;
    validations.minValue = minValue !== null && minValue !== void 0 ? minValue : validations.minValue;
    validations.maxValue = maxValue !== null && maxValue !== void 0 ? maxValue : validations.maxValue;
    validations.inputType = inputType !== null && inputType !== void 0 ? inputType : validations.inputType;
    validations.validationFunc = validationFunc !== null && validationFunc !== void 0 ? validationFunc : validations.validationFunc;
    validations.customFunc = customFunc !== null && customFunc !== void 0 ? customFunc : validations.customFunc;
    validations.dynamicValidation = dynamicValidation !== null && dynamicValidation !== void 0 ? dynamicValidation : validations.dynamicValidation;
    validations.warningText = warningText !== null && warningText !== void 0 ? warningText : validations.warningText;
    validations.forbiddenInputRegex = forbiddenInputRegex !== null && forbiddenInputRegex !== void 0 ? forbiddenInputRegex : validations.forbiddenInputRegex;
  }

  return validations;
};
var verifyValidInput = function verifyValidInput(value, validationObject) {
  var regexPattern = validationObject.regexPattern,
      minLength = validationObject.minLength,
      maxLength = validationObject.maxLength,
      minValue = validationObject.minValue,
      maxValue = validationObject.maxValue,
      validationFunc = validationObject.validationFunc,
      customFunc = validationObject.customFunc,
      warningText = validationObject.warningText;
  var isValid = true;
  var validationText = '';

  if (customFunc) {
    return customFunc(value);
  }

  if (validationFunc) {
    var _validationFunc = validationFunc(value),
        isValidByFunc = _validationFunc.isValid,
        validationTextByFunc = _validationFunc.validationText;

    isValid = isValidByFunc;
    validationText = validationTextByFunc;
  }

  if (minLength && value.length < minLength) {
    isValid = false; // validationText = 'Input is too short';
  }

  if (maxLength && value.length > maxLength) {
    isValid = false; // validationText = 'Input is too long';
  }

  if (minValue && value < minValue) {
    isValid = false;
    validationText = 'Input is too small';
  }

  if (maxValue && value > maxValue) {
    isValid = false;
    validationText = 'Input is too big';
  }

  if (regexPattern && !new RegExp(regexPattern).test(value)) {
    isValid = false;

    if (maxLength && value.length >= maxLength) {
      validationText = 'Incorrect values provided';
    }
  }

  if (warningText) {
    validationText = warningText;
  }

  return {
    isValid: isValid,
    validationText: validationText
  };
};

var _templateObject$5, _templateObject2$5;
var LeftIconSpan = styled.span(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  z-index: 3;\n  position: absolute;\n  width: 13px;\n  height: 18px;\n  left: 21px;\n  top: calc(50% - 9px);\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n"])));
var ValidationIconSpan = styled.span(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  right: 19px;\n  width: 32px;\n  height: 32px;\n  background-color: #eeeeee;\n  border-radius: 50%;\n  z-index: 200;\n  transform: translateY(-50%);\n\n  ", "\n  ", "\n    ", "\n"])), function (props) {
  return props !== null && props !== void 0 && props.isValid ? "\n    background: ".concat(mainGreen, " center no-repeat;\n    background-size: auto;\n    animation: fadeIn 0.4s;\n    & svg {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translateY(-50%);\n      transform: translateX(-50%) translateY(-50%);\n      }\n    ") : "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.iconType) === 'gift' && props !== null && props !== void 0 && props.isValid ? "\n      background: url('../assets/gift-validation-icon.svg') ".concat(mainGreen, " center no-repeat;\n      background-size: auto;\n      animation: fadeIn 0.4s;\n\n      & svg {\n      width: 25px;\n      height: 25px;\n      }\n    ") : "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.iconType) === 'lock' ? "\n      background: transparent;\n      & svg {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translateY(-50%);\n      transform: translateX(-50%) translateY(-50%);\n      width: 20px;\n      height: 25px;\n      }\n      input:has(span)  {\n        caret-color: #171717;\n        color: #16ca92;\n        font-size: 18px;\n        letter-spacing: 6px;\n        min-width: 343px;\n        max-width: 412px;\n        }\n      }\n    " : "";
});

var VALIDATION_ICONS = {
  check: /*#__PURE__*/React.createElement(ValidationCheckIcon, {
    color: "#ffffff"
  }),
  gift: /*#__PURE__*/React.createElement(ValidationGiftIcon, null),
  lock: /*#__PURE__*/React.createElement(LockIcon, null)
};
var FreeInput = function FreeInput(_ref) {
  var id = _ref.id,
      _ref$subtype = _ref.subtype,
      subtype = _ref$subtype === void 0 ? 'text' : _ref$subtype,
      placeholder = _ref.placeholder,
      onInputChange = _ref.onInputChange,
      _ref$stateValue = _ref.stateValue,
      stateValue = _ref$stateValue === void 0 ? '' : _ref$stateValue,
      _ref$leftIconSrc = _ref.leftIconSrc,
      leftIconSrc = _ref$leftIconSrc === void 0 ? '' : _ref$leftIconSrc,
      leftBtn = _ref.leftBtn,
      rightBtn = _ref.rightBtn,
      _ref$shouldValidate = _ref.shouldValidate,
      shouldValidate = _ref$shouldValidate === void 0 ? true : _ref$shouldValidate,
      _ref$validationIconTy = _ref.validationIconType,
      validationIconType = _ref$validationIconTy === void 0 ? '' : _ref$validationIconTy,
      _ref$showWarning = _ref.showWarning,
      showWarning = _ref$showWarning === void 0 ? false : _ref$showWarning,
      _ref$showUnderText = _ref.showUnderText,
      showUnderText = _ref$showUnderText === void 0 ? false : _ref$showUnderText,
      _ref$errorAnimation = _ref.errorAnimation,
      errorAnimation = _ref$errorAnimation === void 0 ? 'fadeIn' : _ref$errorAnimation,
      _ref$errorText = _ref.errorText,
      errorText = _ref$errorText === void 0 ? '' : _ref$errorText,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
      _ref$inputName = _ref.inputName,
      inputName = _ref$inputName === void 0 ? '' : _ref$inputName,
      reference = _ref.reference,
      _ref$testid = _ref.testid,
      testid = _ref$testid === void 0 ? '' : _ref$testid,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? '1' : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? '' : _ref$maxValue,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? '' : _ref$currency,
      _ref$hideLastDigitsSS = _ref.hideLastDigitsSSN,
      hideLastDigitsSSN = _ref$hideLastDigitsSS === void 0 ? false : _ref$hideLastDigitsSS;

  var _useState = useState(stateValue),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(shouldValidate ? false : true),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(errorText),
      _useState6 = _slicedToArray(_useState5, 2),
      warningText = _useState6[0],
      setWarningText = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      displayText = _useState8[0],
      setDisplayText = _useState8[1];

  var _useState9 = useState(shouldValidate ? getValidationsByType(subtype, {}) : null),
      _useState10 = _slicedToArray(_useState9, 2),
      validation = _useState10[0],
      setValidation = _useState10[1];

  useEffect(function () {
    if (!shouldValidate) {
      setValidation(null);
    } else {
      var _verifyValidInput;

      var validationsObject = {};

      switch (subtype) {
        case 'datetime':
        case 'date':
          {
            setDisplayText('mm/dd/yyyy');
            setInputValue(normalizeDateFromQuestionnaire(stateValue));
            break;
          }

        case 'currency':
          {
            validationsObject.minValue = Number(minValue);
            validationsObject.maxValue = Number(maxValue);
            break;
          }
      }

      switch (inputName) {
        case 'firstName':
        case 'lastName':
          {
            validationsObject.forbiddenInputRegex = /^[^A-Za-z-]+$/;
            break;
          }
      }

      var newValidation = getValidationsByType(subtype, validationsObject);
      setIsValid((_verifyValidInput = verifyValidInput(inputValue, newValidation)) === null || _verifyValidInput === void 0 ? void 0 : _verifyValidInput.isValid);
      setValidation(newValidation);
    }
  }, []);
  useEffect(function () {
    if (validation && stateValue) {
      validateInput(inputValue);
    }
  }, [validation]);

  var validateInput = function validateInput(value) {
    var isValidInput = true;

    if (validation) {
      var inputValidated = validation && verifyValidInput(value, validation);
      isValidInput = inputValidated === null || inputValidated === void 0 ? void 0 : inputValidated.isValid;
      setWarningText(inputValidated === null || inputValidated === void 0 ? void 0 : inputValidated.validationText);
    }

    setIsValid(isValidInput);
    var customInputChange = getCustomInputChange(subtype);

    if (customInputChange) {
      var _customInputChange = customInputChange(value, hideLastDigitsSSN),
          customValue = _customInputChange.customValue,
          customDisplayText = _customInputChange.customDisplayText;

      if (customDisplayText !== undefined && customDisplayText !== null) {
        setDisplayText("".concat(currency).concat(customDisplayText));
      }

      if (customValue !== undefined && customValue !== null) {
        value = customValue;
      }
    }

    if (onInputChange) {
      onInputChange(value, isValidInput);
    }
  };

  var handleInputChange = function handleInputChange(e) {
    var target = e.target;
    var value = target.value;

    if (validation) {
      var forbiddenInputRegex = validation.forbiddenInputRegex,
          maxLength = validation.maxLength;

      if (forbiddenInputRegex) {
        value = value.replace(forbiddenInputRegex, '');
      }

      if (maxLength && value.length > maxLength) {
        value = value.slice(0, -1);
      }
    }

    setInputValue(value);
    validateInput(value);
  };

  var leftIconComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement(LeftIconSpan, null, /*#__PURE__*/React.createElement(Image, {
      src: leftIconSrc,
      alt: "".concat(subtype, " input icon"),
      attributes: {
        width: 13,
        height: 18
      }
    }));
  }, [leftIconSrc]);
  var validationIconComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement(ValidationIconSpan, {
      isValid: isValid,
      iconType: validationIconType
    }, subtype === 'password' ? VALIDATION_ICONS[validationIconType] : isValid && VALIDATION_ICONS[validationIconType]);
  }, [validationIconType, isValid]);
  return /*#__PURE__*/React.createElement(BaseInput, {
    id: id,
    type: (validation === null || validation === void 0 ? void 0 : validation.inputType) || 'text',
    name: inputName,
    value: inputValue,
    placeholder: placeholder,
    displayText: displayText,
    handleChange: handleInputChange,
    leftIcon: leftIconSrc ? leftIconComponent : undefined,
    leftBtn: leftBtn,
    rightBtn: rightBtn,
    validationIcon: validationIconType ? validationIconComponent : undefined,
    isInputValid: isValid,
    errorAnimation: errorAnimation,
    errorText: !isValid && showWarning ? warningText : '',
    underText: isValid && showUnderText ? warningText : '',
    autoComplete: autoComplete,
    reference: reference,
    testid: testid
  });
};

var _templateObject$4, _templateObject2$4, _templateObject3$4, _templateObject4$3, _templateObject5$1, _templateObject6;
var AddressContainer = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row wrap;\n  & > *:not(:nth-of-type(1)) {\n    padding-top: 16px;\n  }\n  & ~ * {\n    padding-top: 8px;\n  }\n"])));
var StreetAddress = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  flex-basis: 100%;\n"])));
var StreetAddress2 = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  flex-basis: 100%;\n"])));
var City = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  flex-basis: 100%;\n"])));
var State = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  flex-basis: 66%;\n"])));
var ZipCode = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-left: 8px;\n  flex-basis: 34%;\n"])));

var stringFullAddress = function stringFullAddress(address) {
  var street_address = address.street_address,
      street_address_2 = address.street_address_2,
      city = address.city,
      state = address.state,
      zip_code = address.zip_code;
  var streetString = street_address ? "".concat(street_address, ", ") : '';
  var street2String = street_address_2 ? "".concat(street_address_2, ", ") : '';
  var cityString = city ? "".concat(city, ", ") : '';
  var stateString = state ? "".concat(state, ", ") : '';
  var zipcodeString = zip_code ? "".concat(zip_code) : '';
  return "".concat(streetString).concat(street2String).concat(cityString).concat(stateString).concat(zipcodeString);
};

var ManualAddress = function ManualAddress(_ref) {
  var address = _ref.address,
      onInputChange = _ref.onInputChange;

  var handleNewInput = function handleNewInput(value, key, isValueValid) {
    address[key] = value;
    address['fullAddress'] = stringFullAddress(address);
    var isFormValid = true;

    for (var _i = 0, _Object$entries = Object.entries(address); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          fieldKey = _Object$entries$_i[0],
          fieldValue = _Object$entries$_i[1];

      if (!fieldValue && fieldKey !== 'street_address_2') {
        isFormValid = false;
      }
    }

    if (!isValueValid) {
      isFormValid = false;
    }

    onInputChange(address, isFormValid);
  };

  return /*#__PURE__*/React.createElement(AddressContainer, {
    "data-testid": "manual-address-wrapper"
  }, /*#__PURE__*/React.createElement(StreetAddress, null, /*#__PURE__*/React.createElement(FreeInput, {
    key: "street_address",
    id: "street_address",
    inputName: "address",
    subtype: "text",
    placeholder: "Street Address",
    stateValue: address['street_address'] || '',
    onInputChange: function onInputChange(value, isValid) {
      handleNewInput(value, 'street_address', isValid);
    },
    showWarning: true,
    autoComplete: "street-line1",
    testid: "address"
  })), /*#__PURE__*/React.createElement(StreetAddress2, null, /*#__PURE__*/React.createElement(FreeInput, {
    key: "street_address2",
    id: "street_address2",
    subtype: "text",
    inputName: "address2",
    placeholder: "Street Address 2",
    stateValue: address['street_address_2'] || '',
    onInputChange: function onInputChange(value, isValid) {
      handleNewInput(value, 'street_address_2', isValid);
    },
    shouldValidate: false,
    showWarning: false,
    autoComplete: "street-line2",
    testid: "address2"
  })), /*#__PURE__*/React.createElement(City, null, /*#__PURE__*/React.createElement(FreeInput, {
    key: "city_address",
    id: "city_address",
    subtype: "text",
    inputName: "city",
    placeholder: "City",
    stateValue: address['city'] || '',
    onInputChange: function onInputChange(value, isValid) {
      handleNewInput(value, 'city', isValid);
    },
    showWarning: true,
    autoComplete: "street-level2",
    testid: "city"
  })), /*#__PURE__*/React.createElement(State, null, /*#__PURE__*/React.createElement(ListInput, {
    stateValue: address['state'] || '',
    key: "state_address",
    id: "state_address",
    placeholder: "State",
    onItemSelect: function onItemSelect(newValue) {
      handleNewInput(newValue, 'state', true);
    },
    errorText: "",
    list: statesList
  })), /*#__PURE__*/React.createElement(ZipCode, null, /*#__PURE__*/React.createElement(FreeInput, {
    key: "zipcode_address",
    id: "zipcode_address",
    subtype: "zipcode",
    inputName: "zipcode",
    placeholder: "Zip Code",
    stateValue: address['zip_code'] || '',
    onInputChange: function onInputChange(value, isValid) {
      handleNewInput(value, 'zip_code', isValid);
    },
    showWarning: true,
    showUnderText: false,
    autoComplete: "postal-code",
    testid: "zipcode"
  })));
};

var VIEW_TEXT = {
  google: {
    text: "Can't find the address? ",
    link: "Enter it manually"
  },
  manual: {
    text: "Switch back to ",
    link: "address search"
  }
};
var Address = function Address(_ref) {
  var onAddressChange = _ref.onAddressChange,
      addressValueFromQuestionnaireState = _ref.addressValueFromQuestionnaireState;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isGoogleAddressView = _useState2[0],
      setIsGoogleAddressView = _useState2[1];

  var _useState3 = useState(VIEW_TEXT.google),
      _useState4 = _slicedToArray(_useState3, 2),
      switchViewsText = _useState4[0],
      setSwitchViewsText = _useState4[1];

  var _useState5 = useState(prepareFullAddressValues(addressValueFromQuestionnaireState) || {}),
      _useState6 = _slicedToArray(_useState5, 2),
      address = _useState6[0],
      setAddress = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isAddressValid = _useState8[0],
      setIsAddressValid = _useState8[1];

  useEffect(function () {
    onAddressChange(address, isAddressValid);
  }, [address, isAddressValid]);

  var handleSwitchViews = function handleSwitchViews() {
    setIsGoogleAddressView(!isGoogleAddressView);
    setSwitchViewsText(switchViewsText === VIEW_TEXT.manual ? VIEW_TEXT.google : VIEW_TEXT.manual);
  };

  var handleAddressChange = function handleAddressChange(newAddress, isNewAddressValid) {
    setAddress(_objectSpread2({}, newAddress));
    setIsAddressValid(isNewAddressValid);
  };

  return /*#__PURE__*/React.createElement(AddressWrapper, {
    "data-testid": "address-wrapper"
  }, isGoogleAddressView ? /*#__PURE__*/React.createElement(GoogleAddress, {
    address: address,
    isAddressFormValid: isAddressValid,
    onInputChange: handleAddressChange,
    changeView: handleSwitchViews
  }) : /*#__PURE__*/React.createElement(ManualAddress, {
    address: address,
    onInputChange: handleAddressChange
  }), /*#__PURE__*/React.createElement(SwitchViews, {
    "data-testid": "switch-views"
  }, switchViewsText.text, /*#__PURE__*/React.createElement(SwitchViewsLink, {
    onClick: handleSwitchViews,
    "data-testid": "switch-views-link"
  }, switchViewsText.link)));
};

var _templateObject$3, _templateObject2$3, _templateObject3$3, _templateObject4$2;
var DropdownContainer = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  animation: fadeInAndUp 1s both;\n  flex-grow: 1;\n  z-index: 10;\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 60px;\n  color: ", ";\n  cursor: pointer;\n"])), black);
var DropdownArrow = styled.span(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 90%;\n  width: 13px;\n  cursor: pointer;\n  top: 43%;\n  pointer-events: none;\n\n  & svg {\n    position: absolute;\n  }\n"])));
var DropdownSelect = styled.select(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  background-color: #fff;\n  outline: none;\n  height: 100%;\n  width: 100%;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  padding-left: 16px;\n  font-size: 18px;\n  font-weight: 400;\n  letter-spacing: -0.2px;\n  color: ", ";\n  align-items: center;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  ", "\n"])), darkGrey, greyscale4, mainGreen, function (props) {
  return props !== null && props !== void 0 && props.isSelected ? "\n    font-weight: 600;\n    color: ".concat(black, "; \n    border-color: ").concat(darkGreen, ";\n    &:hover {\n      border-color: ").concat(darkGreen, ";\n    }\n    ") : '';
});
var DropdownOption = styled.option(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral([""])));

var Dropdown = function Dropdown(_ref) {
  var _defaultAnswer$data;

  var _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'dropdown' : _ref$dataTestId,
      stateValue = _ref.stateValue,
      list = _ref.list,
      placeholder = _ref.placeholder,
      onItemSelect = _ref.onItemSelect,
      defaultAnswer = _ref.defaultAnswer,
      questionProfileKey = _ref.questionProfileKey;

  var findAnswerId = function findAnswerId(value) {
    var _list$find;

    return ((_list$find = list.find(function (answer) {
      var _answer$config;

      return (answer === null || answer === void 0 ? void 0 : (_answer$config = answer.config) === null || _answer$config === void 0 ? void 0 : _answer$config.profileValue) === value || answer.data.text === value;
    })) === null || _list$find === void 0 ? void 0 : _list$find.id) || '';
  };

  var defaultAnswerValue = defaultAnswer === null || defaultAnswer === void 0 ? void 0 : (_defaultAnswer$data = defaultAnswer.data) === null || _defaultAnswer$data === void 0 ? void 0 : _defaultAnswer$data.text;
  var validatedStateValue = findAnswerId(stateValue) ? stateValue : null;
  var selectRef = useRef(null);

  var _useState = useState((validatedStateValue !== null && validatedStateValue !== void 0 ? validatedStateValue : !defaultAnswerValue) ? placeholder : defaultAnswerValue),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDisplayVal = _useState2[0],
      setSelectedDisplayVal = _useState2[1];

  useEffect(function () {
    if (validatedStateValue) {
      onChangeHandler(validatedStateValue);
    }
  }, [validatedStateValue]);

  var onChangeHandler = function onChangeHandler(value) {
    setSelectedDisplayVal(value);
    onItemSelect(value, findAnswerId(value));
  };

  return /*#__PURE__*/React.createElement(DropdownContainer, {
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(DropdownArrow, null, /*#__PURE__*/React.createElement(DropdownArrowIcon, null)), /*#__PURE__*/React.createElement(DropdownSelect, {
    value: selectedDisplayVal,
    isSelected: selectedDisplayVal !== placeholder,
    ref: selectRef,
    "data-element": "popup",
    "data-testid": "dropdown-select",
    onChange: function onChange(e) {
      return onChangeHandler(e.target.value);
    }
  }, !defaultAnswerValue ? /*#__PURE__*/React.createElement(DropdownOption, {
    disabled: true
  }, placeholder) : null, list.map(function (answer) {
    var _answer$config2, _answer$data, _answer$config3, _answer$data2, _answer$data3;

    return /*#__PURE__*/React.createElement(DropdownOption, {
      "data-testid": "dropdown-select-item ".concat(answer === null || answer === void 0 ? void 0 : answer.id),
      key: answer === null || answer === void 0 ? void 0 : answer.id,
      id: answer === null || answer === void 0 ? void 0 : answer.id,
      value: (answer === null || answer === void 0 ? void 0 : (_answer$config2 = answer.config) === null || _answer$config2 === void 0 ? void 0 : _answer$config2.profileValue) || (answer === null || answer === void 0 ? void 0 : (_answer$data = answer.data) === null || _answer$data === void 0 ? void 0 : _answer$data.text),
      "data-pixel-label": getPixelLabelJSON(questionProfileKey, (answer === null || answer === void 0 ? void 0 : (_answer$config3 = answer.config) === null || _answer$config3 === void 0 ? void 0 : _answer$config3.profileValue) || (answer === null || answer === void 0 ? void 0 : (_answer$data2 = answer.data) === null || _answer$data2 === void 0 ? void 0 : _answer$data2.text) || '')
    }, answer === null || answer === void 0 ? void 0 : (_answer$data3 = answer.data) === null || _answer$data3 === void 0 ? void 0 : _answer$data3.text);
  })));
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$1;
var ControllerBtn = styled.button(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 100%;\n  background: none;\n  border: none;\n  position: absolute;\n  z-index: 4;\n  cursor: pointer;\n  ", "\n  ", "\n\n  & > svg {\n    width: 10px;\n    height: 10px;\n  }\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.position) === 'left' && 'left: 20px;';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.position) === 'right' && 'right: 20px;';
});
var RangeSliderWrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  height: 40px;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin-bottom: 8px;\n\n  & > svg {\n    position: absolute;\n    width: 100%;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    justify-content: center;\n\n    & > svg {\n      width: 80%;\n    }\n  }\n"])), minDesktopWidth);
var RangeSliderThumb = "\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  height: 28px;\n  width: 28px;\n  background-color: ".concat(mainGreen, ";\n  border: 2px solid #fff;\n  border-radius: 50%;\n  box-shadow: -3px 3px 9px rgba(0, 0, 0, 0.5);\n");
var RangeSliderInput = styled.input(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  z-index: 4;\n  position: absolute;\n  background-color: transparent;\n  appearance: none;\n  width: 100%;\n\n  &::-moz-range-thumb {\n    ", ";\n  }\n\n  &::-webkit-slider-thumb {\n    ", ";\n  }\n\n  &::-ms-thumb {\n    ", ";\n  }\n\n  @media (min-width: ", ") {\n    width: 80%;\n  }\n"])), RangeSliderThumb, RangeSliderThumb, RangeSliderThumb, minDesktopWidth);
var ValueSpan = styled.span(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: -15px;\n  ", "\n  font-size: 14px;\n  color: ", ";\n\n  @media (min-width: ", ") {\n    bottom: 12px;\n    ", "\n  }\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.position) === 'right' ? 'right: -10px;' : 'left: -10px;';
}, darkGrey, minDesktopWidth, function (props) {
  return (props === null || props === void 0 ? void 0 : props.position) === 'right' ? 'right: -30px;' : 'left: -20px;';
});

var RangeSlider = function RangeSlider(_ref) {
  var min = _ref.min,
      max = _ref.max,
      currency = _ref.currency,
      inputValue = _ref.inputValue,
      increments = _ref.increments,
      onChange = _ref.onChange;
  var handleChange = throttle(function (value) {
    if (onChange) {
      onChange(value);
    }
  }, 300);
  return /*#__PURE__*/React.createElement(RangeSliderWrapper, {
    "data-testid": "range-slider-wrapper"
  }, /*#__PURE__*/React.createElement(ValueSpan, {
    "data-testid": "min-value-span"
  }, normalizeCurrencyValue(currency, min)), /*#__PURE__*/React.createElement(RangeSlider$1, null), /*#__PURE__*/React.createElement(RangeSliderInput, {
    type: "range",
    min: min,
    max: max,
    onChange: function onChange(e) {
      return handleChange(e.target.value.toString());
    },
    step: increments,
    value: +inputValue,
    "data-testid": "range-slider-input"
  }), /*#__PURE__*/React.createElement(ValueSpan, {
    position: "right",
    "data-testid": "max-value-span"
  }, normalizeCurrencyValue(currency, max)));
};

var normalizeCurrencyValue = function normalizeCurrencyValue(currency, value) {
  return "".concat(currency).concat(Number(value).toLocaleString());
};
var Range = function Range(_ref) {
  var id = _ref.id,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? '100000' : _ref$initialValue,
      onInputChange = _ref.onInputChange,
      stateValue = _ref.stateValue,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? '0' : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? '1000000' : _ref$maxValue,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? '$' : _ref$currency,
      _ref$increments = _ref.increments,
      increments = _ref$increments === void 0 ? 500 : _ref$increments;

  var _useState = useState(stateValue || initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(function () {
    return normalizeCurrencyValue(currency, stateValue || initialValue);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      displayValue = _useState4[0],
      setDisplayValue = _useState4[1];

  useEffect(function () {
    if (onInputChange) {
      onInputChange(inputValue);
    }

    setDisplayValue(normalizeCurrencyValue(currency, inputValue));
  }, [inputValue]);

  var handleIconClick = function handleIconClick(value) {
    var newVal = Number.parseInt(inputValue, 10) + value;

    if (newVal >= minValue && newVal <= maxValue) {
      setInputValue(newVal.toString());
    }
  };

  var leftBtn = /*#__PURE__*/React.createElement(ControllerBtn, {
    position: "left",
    onClick: function onClick() {
      return handleIconClick(-increments);
    },
    "data-testid": "controller-dec"
  }, /*#__PURE__*/React.createElement(MinusIcon, null));
  var rightBtn = /*#__PURE__*/React.createElement(ControllerBtn, {
    position: "right",
    onClick: function onClick() {
      return handleIconClick(increments);
    },
    "data-testid": "controller-add"
  }, /*#__PURE__*/React.createElement(PlusIcon, null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FreeInput, {
    id: id,
    key: "range".concat(displayValue),
    shouldValidate: false,
    subtype: "rangeSlider",
    inputName: "rangeSlider",
    placeholder: "",
    onInputChange: function onInputChange() {},
    stateValue: displayValue,
    leftBtn: leftBtn,
    rightBtn: rightBtn,
    testid: "range-slider-input-box"
  }), /*#__PURE__*/React.createElement(RangeSlider, {
    min: minValue,
    max: maxValue,
    currency: currency,
    increments: increments,
    inputValue: inputValue,
    onChange: function onChange(value) {
      return setInputValue(value);
    }
  }));
};

var _templateObject$1, _templateObject2$1, _templateObject3$1;
var ListWrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 16px 0;\n  width: 100%;\n  justify-items: center;\n  align-items: center;\n  max-width: 656px;\n"])));
var SingleChoiceListItem = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row wrap;\n  min-width: 110px;\n  width: 100%;\n  height: 48px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  justify-content: center;\n  align-items: center;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  cursor: pointer;\n\n  ", "\n\n  @media (min-width: ", ") {\n    &:hover {\n      cursor: pointer;\n      border-color: ", ";\n      box-shadow: 1px 1px 7px 0px #00000036;\n\n      & p {\n        color: ", ";\n      }\n    }\n  }\n"])), greyscale4, function (props) {
  return props !== null && props !== void 0 && props.isSelected ? "\n      border-color: ".concat(mainGreen, ";\n      & p {\n        color: ").concat(mainGreen, ";\n      }") : '';
}, minDesktopWidth, mainGreen, mainGreen);
var SingleChoiceListItemText = styled.p(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  margin: 6px 0;\n  flex-basis: 100%;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  letter-spacing: -0.2px;\n  color: ", ";\n  text-align: center;\n  transition: color 0.3s;\n"])), black);

var SingleChoice = function SingleChoice(_ref) {
  var _ref$subtype = _ref.subtype,
      subtype = _ref$subtype === void 0 ? 'list' : _ref$subtype,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      placeholder = _ref.placeholder,
      maxAnswers = _ref.maxAnswers,
      onSelectAnswer = _ref.onSelectAnswer,
      currentQuestionValue = _ref.currentQuestionValue,
      questionProfileKey = _ref.questionProfileKey;

  var _useState = useState(list),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      extraListItems = _useState4[0],
      setExtraListItems = _useState4[1];

  var _useState5 = useState(currentQuestionValue),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedAnswer = _useState6[0],
      setSelectedAnswer = _useState6[1];

  useEffect(function () {
    if (maxAnswers && list.length > maxAnswers) {
      setListItems(list.slice(0, maxAnswers));
      setExtraListItems(list.slice(maxAnswers));
    } else {
      setListItems(list);
    }
  }, [maxAnswers, list]);

  var handleSelect = function handleSelect(value, answerId) {
    setSelectedAnswer(value);

    if (onSelectAnswer) {
      onSelectAnswer(value, answerId);
    }
  };

  var isSelectedAnswerInDropDown = selectedAnswer && (extraListItems === null || extraListItems === void 0 ? void 0 : extraListItems.map(function (a) {
    var _a$config, _a$config$profileValu, _a$config$profileValu2, _a$config$profileValu3, _a$config$profileValu4;

    return (_a$config = a.config) === null || _a$config === void 0 ? void 0 : (_a$config$profileValu = _a$config.profileValue) === null || _a$config$profileValu === void 0 ? void 0 : (_a$config$profileValu2 = _a$config$profileValu.toString) === null || _a$config$profileValu2 === void 0 ? void 0 : (_a$config$profileValu3 = (_a$config$profileValu4 = _a$config$profileValu2.call(_a$config$profileValu)).toLowerCase) === null || _a$config$profileValu3 === void 0 ? void 0 : _a$config$profileValu3.call(_a$config$profileValu4);
  }).includes(selectedAnswer.toString().toLowerCase()));

  var getSingleChoiceItem = function getSingleChoiceItem(props) {
    var isSelected = props.isSelected,
        answerId = props.answerId,
        text = props.text,
        value = props.value,
        onSelect = props.onSelect,
        pixelLabel = props.pixelLabel,
        dataTestId = props.dataTestId;

    switch (subtype) {
      case 'list':
      default:
        return /*#__PURE__*/React.createElement(SingleChoiceListItem, {
          "data-testid": dataTestId,
          key: answerId,
          isSelected: isSelected,
          onClick: function onClick() {
            return onSelect(value, answerId);
          },
          "data-pixel-label": pixelLabel
        }, /*#__PURE__*/React.createElement(SingleChoiceListItemText, null, text));
    }
  };

  return /*#__PURE__*/React.createElement(ListWrapper, {
    type: subtype,
    "data-testid": "list-items"
  }, listItems.map(function (answer) {
    var _answer$config, _answer$data$text, _answer$data, _answer$config$profil, _answer$config2, _answer$config$profil2, _answer$config3;

    return getSingleChoiceItem({
      dataTestId: "single-choice-dropdown ".concat(answer.id),
      isSelected: ((_answer$config = answer.config) === null || _answer$config === void 0 ? void 0 : _answer$config.profileValue) === selectedAnswer,
      answerId: answer.id,
      text: (_answer$data$text = (_answer$data = answer.data) === null || _answer$data === void 0 ? void 0 : _answer$data.text) !== null && _answer$data$text !== void 0 ? _answer$data$text : '',
      value: (_answer$config$profil = (_answer$config2 = answer.config) === null || _answer$config2 === void 0 ? void 0 : _answer$config2.profileValue) !== null && _answer$config$profil !== void 0 ? _answer$config$profil : '',
      onSelect: handleSelect,
      pixelLabel: getPixelLabelJSON(questionProfileKey, (_answer$config$profil2 = (_answer$config3 = answer.config) === null || _answer$config3 === void 0 ? void 0 : _answer$config3.profileValue) !== null && _answer$config$profil2 !== void 0 ? _answer$config$profil2 : '')
    });
  }), extraListItems.length > 0 && /*#__PURE__*/React.createElement(Dropdown, {
    dataTestId: "extra-list-items",
    stateValue: isSelectedAnswerInDropDown ? selectedAnswer : '',
    list: extraListItems,
    placeholder: placeholder,
    key: "extraListItems",
    onItemSelect: handleSelect,
    questionProfileKey: questionProfileKey
  }));
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var ConsentWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: -35px;\n"])));
var HiddenInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var ConsentBody = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var ConsentContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-width: 396px;\n  font-size: 12px;\n  line-height: 15px;\n  text-align: left;\n  a {\n    color: ", ";\n    span {\n      font-weight: 600;\n    }\n  }\n"])), linkBlue);
styled.a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 600;\n  text-decoration: underline;\n"])), linkBlue);

var UserConsent = function UserConsent(_ref) {
  var _ref$consentText = _ref.consentText,
      consentText = _ref$consentText === void 0 ? '' : _ref$consentText,
      onChange = _ref.onChange;
  useEffect(function () {
    onChange();
  }, []);
  return /*#__PURE__*/React.createElement(ConsentWrapper, {
    "data-testid": "user-consent"
  }, /*#__PURE__*/React.createElement(HiddenInput, {
    type: "hidden",
    id: "leadid_tcpa_disclosure",
    "data-testid": "user-consent-input"
  }), /*#__PURE__*/React.createElement(ConsentBody, {
    htmlFor: "leadid_tcpa_disclosure"
  }, /*#__PURE__*/React.createElement(ConsentContent, {
    dangerouslySetInnerHTML: {
      __html: consentText
    }
  })));
};

var findDisplayValue = function findDisplayValue(answerId, answers) {
  var _answers$find, _answers$find$data;

  return ((_answers$find = answers.find(function (answer) {
    return (answer === null || answer === void 0 ? void 0 : answer.id) === answerId;
  })) === null || _answers$find === void 0 ? void 0 : (_answers$find$data = _answers$find.data) === null || _answers$find$data === void 0 ? void 0 : _answers$find$data.text) || '';
};

var PrequalInputFactory = function PrequalInputFactory(_ref) {
  var _stepAttributes$find;

  var question = _ref.question,
      handleQuestionInputChange = _ref.handleQuestionInputChange,
      questionInputValueFromQuestionnaire = _ref.questionInputValueFromQuestionnaire,
      stepAttributes = _ref.stepAttributes,
      cdnContextProps = _ref.cdnContextProps;
  var type = question.type,
      answers = question.answers,
      questionData = question.data,
      questionConfig = question.config,
      questionId = question.id,
      name = question.name;

  var _ref2 = questionConfig || {},
      _ref2$profileKey = _ref2.profileKey,
      profileKey = _ref2$profileKey === void 0 ? '' : _ref2$profileKey;

  var assetsCdn = cdnContextProps.assetsCdn,
      env = cdnContextProps.env;

  var handleInputChange = function handleInputChange(value, isInputValid) {
    var answerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    handleQuestionInputChange(profileKey || name || '', value, findDisplayValue(answerId, answers) || (typeof value === 'string' ? value : ''), isInputValid, questionId, answerId);
  };

  switch (profileKey) {
    // for special cases that require entire step management (Address & google address, vehicles...)
    // or special case questions (consent...)
    case 'fullAddress':
      {
        return /*#__PURE__*/React.createElement(Address, {
          onAddressChange: function onAddressChange(value, isValid) {
            return handleInputChange(value, isValid);
          },
          addressValueFromQuestionnaireState: questionInputValueFromQuestionnaire
        });
      }

    case 'privacy_terms_approved':
      return /*#__PURE__*/React.createElement(UserConsent, {
        onChange: function onChange() {
          return handleInputChange({
            privacy_terms_approved: true,
            tcpa: true,
            tcpa_optinDate: new Date()
          }, true);
        },
        consentText: ((_stepAttributes$find = stepAttributes.find(function (att) {
          return att.name === 'consent';
        })) === null || _stepAttributes$find === void 0 ? void 0 : _stepAttributes$find.value.text) || ''
      });
  }

  switch (type) {
    case 'freeInput':
      {
        var _stepAttributes$find2, _stepAttributes$find3, _image$url;

        var _answers$ = answers[0],
            answerData = _answers$.data,
            inputType = _answers$.inputType,
            _answerId = _answers$.id,
            answerConfig = _answers$.config; // input type should be changed(?) to subtype in xbox/questionnaire

        var placeHolder = answerData.placeHolder,
            image = answerData.image;

        var _ref3 = answerConfig || {},
            min = _ref3.min,
            max = _ref3.max,
            suffix = _ref3.suffix;

        var hideLast4DigitsSsn = (_stepAttributes$find2 = stepAttributes.find(function (stepAttr) {
          return (stepAttr === null || stepAttr === void 0 ? void 0 : stepAttr.name) === 'hideLast4DigitsSsn';
        })) === null || _stepAttributes$find2 === void 0 ? void 0 : (_stepAttributes$find3 = _stepAttributes$find2.value) === null || _stepAttributes$find3 === void 0 ? void 0 : _stepAttributes$find3.text;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FreeInput, {
          id: _answerId,
          subtype: inputType,
          inputName: getInputNameValue(profileKey),
          placeholder: placeHolder,
          stateValue: questionInputValueFromQuestionnaire || '',
          onInputChange: function onInputChange(value, isValid) {
            return handleInputChange(value, isValid, _answerId);
          },
          showWarning: true,
          showUnderText: true,
          leftIconSrc: cdnData((_image$url = image === null || image === void 0 ? void 0 : image.url) !== null && _image$url !== void 0 ? _image$url : '', assetsCdn, env) || '' // add validation icon in question xbox fields, icon to provided from questionnaire
          ,
          validationIconType: getValidationIconByProfileKey(profileKey),
          errorAnimation: 'fadeIn',
          errorText: '',
          autoComplete: getAutoCompleteValue(profileKey),
          minValue: min,
          maxValue: max,
          currency: suffix,
          hideLastDigitsSSN: hideLast4DigitsSsn ? hideLast4DigitsSsn === 'true' : false
        }));
      }

    case 'singleChoice':
      {
        return /*#__PURE__*/React.createElement(SingleChoice, {
          subtype: 'list' // will be changed to inputType after xbox/questionnaire development
          ,
          list: answers,
          placeholder: (questionData === null || questionData === void 0 ? void 0 : questionData.placeHolder) || 'Please select',
          maxAnswers: (questionConfig === null || questionConfig === void 0 ? void 0 : questionConfig.maxAllowedAnswers) || 5,
          onSelectAnswer: function onSelectAnswer(value, answerId) {
            return handleInputChange(value, true, answerId);
          },
          currentQuestionValue: questionInputValueFromQuestionnaire || '',
          questionProfileKey: profileKey
        });
      }

    case 'dropDown':
      {
        return /*#__PURE__*/React.createElement(Dropdown, {
          subtype: 'list' // will be changed to inputType after xbox/questionnaire development
          ,
          stateValue: questionInputValueFromQuestionnaire || '',
          list: answers,
          placeholder: questionData === null || questionData === void 0 ? void 0 : questionData.placeHolder,
          onItemSelect: function onItemSelect(value, answerId) {
            return handleInputChange(value, true, answerId);
          },
          questionProfileKey: profileKey
        });
      }

    case 'range':
      {
        var _answers$2 = answers[0],
            _answerData = _answers$2.data,
            _answerId2 = _answers$2.id,
            _answerConfig = _answers$2.config;
        var defaultValue = _answerData.defaultValue;

        var _ref4 = _answerConfig !== null && _answerConfig !== void 0 ? _answerConfig : {},
            _min = _ref4.min,
            _max = _ref4.max,
            step = _ref4.step,
            _suffix = _ref4.suffix;

        return /*#__PURE__*/React.createElement(Range, {
          id: _answerId2,
          initialValue: defaultValue,
          onInputChange: function onInputChange(value) {
            return handleInputChange(value, true, _answerId2);
          },
          stateValue: questionInputValueFromQuestionnaire || '',
          minValue: _min,
          maxValue: _max,
          increments: step,
          currency: _suffix || '$'
        });
      }

    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

PrequalInputFactory.displayName = 'PrequalInputFactory';

export { PrequalInputFactory };
